import React, { useCallback, useState } from 'react'
import { PlainCard, FlexRow } from './components'
import { ConfirmButton } from '@/components/Button'
import Text from '@/components/Text'
import Table from '@/components/Table'
import { shareInfoColumns } from './column'
import { ApplicationShareInfo } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { getNewShareInfoList } from '@/api'
import GenerateShareCode from './generate'

const Share: React.FC<unknown> = () => {
  const [showGenerate, setShowGenerate] = useState<boolean>(false)
  const { data, refetch } = useQuery(['getNewShareInfoList'], getNewShareInfoList, {})

  const onClose = useCallback(() => {
    setShowGenerate(false)
  }, [])

  const onOpenGenerate = useCallback(() => {
    setShowGenerate(true)
  }, [])

  const handleRefetchData = useCallback(() => {
    refetch()
  }, [refetch])

  return (
    <>
      <PlainCard>
        <FlexRow sx={{ justifyContent: 'space-between' }}>
          <Text weight='bold'>分享管理</Text>
          <ConfirmButton onClick={onOpenGenerate}>生成分享链接</ConfirmButton>
        </FlexRow>
        <Table<ApplicationShareInfo & { label?: unknown }>
          rowKey={'code'}
          data={data?.detail ?? []}
          columns={shareInfoColumns}
          pagination={null}
        />
      </PlainCard>
      <GenerateShareCode open={showGenerate} onClose={onClose} refetch={handleRefetchData} />
    </>
  )
}

export default Share
